import { FETCH_APPLICANTS_DATA_FAILURE, FETCH_APPLICANTS_DATA_SUCCESS, SHARED_REPORTS } from '../constants/actionTypes';

export const currentApplicationInitState = {
  sharedReports: {}, // Only needed by screening-js.
  sharedReportStatuses: {},
};

function fetchApplicantsDataSuccess(state, payload) {
  const { currentApplication = {} } = payload;
  return {
    ...state,
    ...currentApplication,
  };
}

function fetchApplicantsDataFailure(state, payload) {
  const { currentApplication = {} } = payload;
  return {
    ...state,
    ...currentApplication,
  };
}

function retrieveSharedReports(state, payload) {
  const { applicantId, sharedReports, sharedReportStatuses } = payload;

  return {
    ...state,
    ...(sharedReports && {
      sharedReports: {
        ...state.sharedReports,
        ...{ [applicantId]: sharedReports },
      },
    }),
    ...(sharedReportStatuses && {
      sharedReportStatuses: {
        ...state.sharedReportStatuses,
        ...{ [applicantId]: sharedReportStatuses },
      },
    }),
  };
}

const currentApplication = (state = currentApplicationInitState, action = {}) => {
  const { type, payload } = action;

  let newState;
  switch (type) {
    case FETCH_APPLICANTS_DATA_SUCCESS:
      newState = fetchApplicantsDataSuccess(state, payload);
      break;
    case FETCH_APPLICANTS_DATA_FAILURE:
      newState = fetchApplicantsDataFailure(state, payload);
      break;
    case SHARED_REPORTS:
      newState = retrieveSharedReports(state, payload);
      break;
    default:
      newState = state;
      break;
  }

  return newState;
};

export default currentApplication;
